import { RootContainer } from "@components/ui/PageBaseComponents";
import { TitleContainer } from "@components/ui/PageBaseComponents";
import { PageTitle } from "@components/ui/PageBaseComponents";
import { ContentContainer } from "@components/ui/PageBaseComponents";
import React, { useEffect, useState } from "react";
import Api from "@services/Api";
import { toastError, toastMessage } from "@util/functions";
import { Modal, Button } from "react-bootstrap";

export const PhotoCalendarPage: React.FC = () => {
  const [uploading, setUploading] = useState<File | undefined>(undefined);
  const [previewUrl, setPreviewUrl] = useState<string | undefined>(undefined);
  const [showModal, setShowModal] = useState(false);
  const [activeImage, setActiveImage] = useState<any>();

  const fetchImages = async () => {
    try {
      const { data } = await Api.get("/photo-calendar");
      setActiveImage(data.image);
      return data.images;
    } catch (error) {
      toastError("Erro ao buscar imagens");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchImages();
    if (uploading) {
      const objectUrl = URL.createObjectURL(uploading);
      setPreviewUrl(objectUrl);
      setShowModal(true);

      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [uploading]);

  const handleClose = () => {
    setShowModal(false);
    setUploading(undefined);
    setPreviewUrl(undefined);
  };

  const handleSave = async () => {
    if (!uploading) return;

    try {
      const formData = new FormData();
      formData.append("files", uploading);

      await Api.post("/photo-calendar", formData);

      toastMessage("Imagem salva com sucesso!", "success");
      handleClose();
    } catch (error) {
      toastError("Erro ao salvar imagem");
      console.error(error);
    }
  };

  return (
    <RootContainer>
      <TitleContainer>
        <PageTitle>Editar Foto Calendário</PageTitle>
      </TitleContainer>
      <ContentContainer>
        <input
          className="form-control"
          style={{
            border: "1px solid #ced4da",
            marginBottom: "20px",
            padding: "10px",
            borderRadius: "8px",
          }}
          type="file"
          accept="image/*"
          onChange={(e) => setUploading(e.target?.files?.[0])}
          multiple={false}
        />

        <ContentContainer
          style={{ display: "flex", gap: "12px", flexDirection: "column", margin: "0", minWidth: "100%" }}
        >
          {activeImage ? (
            <>
              <span>Imagem atual:</span>
              <img
                src={activeImage?.url}
                alt="Imagem do calendário"
                style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
              />
            </>
          ) : (
            <span>Sem imagem atual</span>
          )}
        </ContentContainer>

        <Modal show={showModal} onHide={handleClose} centered>
          <Modal.Header>
            <Modal.Title>Pré-visualização</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
            {previewUrl && (
              <img
                src={previewUrl}
                alt="Pré-visualização"
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                }}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </ContentContainer>
    </RootContainer>
  );
};

